export default __webpack_public_path__ + "static/media/background.c031675a.jpg";